import React, { useState } from "react";

import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const LANGUAGES = ["pt-BR", "en-US", "es-ES"];

export default function ContactDrawerLanguage({ contact }) {
	const [selectedLanguage, setSelectedLanguage] = useState(contact?.language || "");

	const handleChange = async (value) => {
		setSelectedLanguage(value);

		try {
			await api.put("/update-language", {
				contactId: contact.id,
				language: value,
			});
		} catch (error) {
			toastError(error);
		}
	};

	return (
		<div className="tailwick-contact-drawer__section">
			<p className="tailwick-filter-panel__section-title">Language default</p>
			<select
				className="form-select w-full"
				value={selectedLanguage}
				onChange={(e) => handleChange(e.target.value)}
			>
				<option value="">{i18n.t("languages.undefined")}</option>
				{LANGUAGES.map((lang) => (
					<option key={lang} value={lang}>
						{i18n.t(`languages.${lang}`) || lang}
					</option>
				))}
			</select>
		</div>
	);
}
